import { SelectValue } from "../components/summary/model/summary.model";
import { MimeTypes } from "../components/upload-file-dnd/model/mimeTypes";

export enum BUTTON_ENUM {
  CONFIRM = "confirm",
  DISCARD = "discard",
  RESET = "reset",
  SUBMIT = "submit",
}

export enum CMS_PAGE_NAME {
  HOME = "home",
  FAQ = "faq",
  VEHICLE_LIST = "vehicle-list",
  PAGA_ONLINE = "paga-online",
  VEHICLE_ASSIGNMENT = "vehicle-assignment",
  VEHICLE_ORDERS = "vehicle-orders",
  CAR_CONFIGURATOR = "car_configurator",
  RICARICAR_DASHBOARD_KM = "ricaricar-dashboard-km",
  RICARICAR_CONSUMPTION_ARCHIVE = "ricaricar-consumption-archive",
  VEHICLE_TAX = "vehicle-tax",
  SANITATION_SERVICE = "sanitation-service",
  CLAIMS_REPORT = "claims-report",
  FINES_POST_ART_94 = "fines-post-art-94",
  REFUELING = "refueling",
  DELEGATION_ART_94 = "delegation-art-94",
  PRELEASE = "prelease",
  SERVICE_CENTERS = "service-centers",
  APPOINTMENTS = "appointments",
  NEW_APPOINTMENT = "new_appointment",
  TIRES_MANAGEMENT = "tires-management",
  TIRES_MOVEMENTS = "tires-movementes",
  MAINTENANCE = "maintenance",
  CONTRACTS = "contracts",
  CONTRACTS_MODIFICATION = "contracts-modification",
  EARLY_RETURN = "early-return",
  VEHICLE_PURCHASE = "vehicle-purchase",
  EXTENSION_OF_DEADLINE = "extension-of-deadline",
  EXPIRING_CONTRACTS = "expiring-contracts",
  INVOICES_ARCHIVE = "invoices-archive",
  ONLINE_PAYMENT = "online-payment",
  INVOICE_RECEPTION_MODE = "invoice-reception-mode",
  CREDIT_CARD_SERVICE = "credit-card-service",
  DOCUMENTS_ARCHIVE = "documents-archive",
  MODULES = "modules",
  INVITES_DRIVERS = "invites-drivers",
  YOUR_DRIVERS = "your-drivers",
  YOUR_COLLABORATORS = "your-collaborators",
  NOTICES_COMMUNICATIONS = "notices-communications",
  CONTACTS = "contacts",
  ASSISTANCE_REQUEST = "assistance-request",
  MANUALS_GUIDES = "manuals-guides",
  ALERT_LIST = "alert-list",
  ORDER_DETAIL = "order-detail",
  WEBFORM = "webform",
  EMPTY = ''
}

export enum FILTER_ENUM {
  FILTERS = "filters",
  FILTER = "filter",
}

export enum DEFAULT_ICON {
  CAR = "directions_car_filled",
  MOTORCYCLE = "two_wheeler",
  VAN = "airport_shuttle",
  USER = "person",
}

export enum KEYWORD {
  GENERAL = "general",
  OUTFITTING = "outfitting",
  PRICE = "price",
  HISTORY = "history",
}

export enum FORMATYPE {
  NUMBER = "number",
  ICON = "icon",
}

export enum Color {
  GREEN = "#9DE0E0",
  ORANGE = "#FFE279",
  RED = "#CF3516",
  VIOLET = "#D77400",
  PINK = "#f87b7c",
  BLUE = "#1C68CA",
  GREY = "#f1f1f1",
  GREESASSIGNED = "#9DE0E0",
  GREEN_DRIVER_STATUS = "#9DE0E0",
  BLU_EX_DRIVER =  "#0F3549",//"#050b7f",
  LIGHT_GREEN = "#EAF8F8",
  CHIP_COLOR="#9de0e0",
  WHITE = "#fff",
  LIGHT_GREY = "#dcdfe2",
  YELLOW = "#FFE279",
  MAIN_BLUE = "#0F3549",//"#050b7f",
  BLUE_2 = "#0F3549",
  BLACK = "#010202"
}

export const selectTitle = [
  {
    id: "Mr",
    value: "mr",
  },
] as Array<SelectValue>;
export const selectGender = [
  {
    id: "F",
    value: "female",
  },
  {
    id: "M",
    value: "male",
  },
] as Array<SelectValue>;

export const mimeTypeAccepted = [
  MimeTypes.jpeg,
  MimeTypes.pdf,
  MimeTypes.rar,
  MimeTypes.png,
  MimeTypes.zip,
  MimeTypes.x7z,
] as Array<MimeTypes>;

export interface Marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  markerDetail?: string;
  markerName?: string;
}
